import { render, staticRenderFns } from "./DashboardHeaderRight.vue?vue&type=template&id=47925eab"
import script from "./DashboardHeaderRight.vue?vue&type=script&lang=js"
export * from "./DashboardHeaderRight.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeaderRight.vue?vue&type=style&index=0&id=47925eab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports